import React from "react";

const Logo = ({ link }) => {
  return <img src={link} alt="QTifyLogo" />;
};

export default Logo;
